import React from 'react';
import NotificationsPage from '../common/NotificationsPage';

const MediatorNotifications = () => <NotificationsPage title="Notifications" />;

export default MediatorNotifications;
